import Vue from 'vue'
import App from './App.vue'
import './plugins/element.js'
import Vuex from 'vuex'
import * as uuid from 'uuid/v4'
Vue.config.productionTip = false

import {
  Pagination,
  Dialog,
  Autocomplete,
  Dropdown,
  DropdownMenu,
  DropdownItem,
  Menu,
  Submenu,
  MenuItem,
  MenuItemGroup,
  Input,
  InputNumber,
  Radio,
  RadioGroup,
  RadioButton,
  Checkbox,
  CheckboxButton,
  CheckboxGroup,
  Switch,
  Select,
  Option,
  OptionGroup,
  Button,
  ButtonGroup,
  Table,
  TableColumn,
  DatePicker,
  TimeSelect,
  TimePicker,
  Popover,
  Tooltip,
  Breadcrumb,
  BreadcrumbItem,
  Form,
  FormItem,
  Tabs,
  TabPane,
  Tag,
  Tree,
  Alert,
  Slider,
  Icon,
  Row,
  Col,
  Upload,
  Progress,
  Badge,
  Card,
  Rate,
  Steps,
  Step,
  Carousel,
  CarouselItem,
  Collapse,
  CollapseItem,
  Cascader,
  ColorPicker,
  Transfer,
  Container,
  Header,
  Aside,
  Main,
  Footer,
  Loading,
  MessageBox,
  Message,
  Notification
} from 'element-ui';

Vue.use(Pagination);
Vue.use(Dialog);
Vue.use(Autocomplete);
Vue.use(Dropdown);
Vue.use(DropdownMenu);
Vue.use(DropdownItem);
Vue.use(Menu);
Vue.use(Submenu);
Vue.use(MenuItem);
Vue.use(MenuItemGroup);
Vue.use(Input);
Vue.use(InputNumber);
Vue.use(Radio);
Vue.use(RadioGroup);
Vue.use(RadioButton);
Vue.use(Checkbox);
Vue.use(CheckboxButton);
Vue.use(CheckboxGroup);
Vue.use(Switch);
Vue.use(Select);
Vue.use(Option);
Vue.use(OptionGroup);
Vue.use(Button);
Vue.use(ButtonGroup);
Vue.use(Table);
Vue.use(TableColumn);
Vue.use(DatePicker);
Vue.use(TimeSelect);
Vue.use(TimePicker);
Vue.use(Popover);
Vue.use(Tooltip);
Vue.use(Breadcrumb);
Vue.use(BreadcrumbItem);
Vue.use(Form);
Vue.use(FormItem);
Vue.use(Tabs);
Vue.use(TabPane);
Vue.use(Tag);
Vue.use(Tree);
Vue.use(Alert);
Vue.use(Slider);
Vue.use(Icon);
Vue.use(Row);
Vue.use(Col);
Vue.use(Upload);
Vue.use(Progress);
Vue.use(Badge);
Vue.use(Card);
Vue.use(Rate);
Vue.use(Steps);
Vue.use(Step);
Vue.use(Carousel);
Vue.use(CarouselItem);
Vue.use(Collapse);
Vue.use(CollapseItem);
Vue.use(Cascader);
Vue.use(ColorPicker);
Vue.use(Transfer);
Vue.use(Container);
Vue.use(Header);
Vue.use(Aside);
Vue.use(Main);
Vue.use(Footer);

Vue.use(Loading.directive);

Vue.use(Vuex)

Vue.prototype.$loading = Loading.service;
Vue.prototype.$msgbox = MessageBox;
Vue.prototype.$alert = MessageBox.alert;
Vue.prototype.$confirm = MessageBox.confirm;
Vue.prototype.$prompt = MessageBox.prompt;
Vue.prototype.$notify = Notification;
Vue.prototype.$message = Message;

import Config from "./Config.vue";

new Vue({
  render: h => h(App),
  data() {
    return {
      testValue: 0,
      basicInfo: {},
      requirements: new Map(), //For submit to backend
      allData: {},
      captcha: {
        captcha: "",
        token: "",
      },
      dialogVisible: false,
      gridData: [],//「總表單」中提供 table 使用的
      subformDialogVisible: false,
      dialogSubmitModifier: false,
      clearFormsConetntAlert: false, // 用於清空表單提示
      willChangeAllFormItemObj: {},
      willChangeAllFormItemUuid: "",
      itemFormData: {}, //用於「總表單」提交修改子表單內容用的表單

      consignmentItems: [],
    }
  },
  methods: {
    // 打開總提交表單
    openTheSubmitForm: function () {
      if (Object.keys(this.basicInfo) == 0) {
        this.$notify.error({
          title: '失敗',
          dangerouslyUseHTMLString: true,
          message: `您还没有填写您的个人信息,您可以返回顶部填写个人信息`,
        });
      } else {
        this.dialogVisible = true
      }
    },

    // 添加內容 过滤器
    contentFilter(requirementObj) {
      let newObj = {}
      if (requirementObj.title == "寄卖相关") {
        const labels = ['作品名称', '数量', '价格', '是否预售', '款式', '尺寸宽', '尺寸长', '瑕疵品是否退回', '是否转发抽奖', '是否需要在官方微博宣传','寄卖同人收藏本','寄卖同人周边']
        for (let i = 0; i < labels.length; i++) {
          if (requirementObj[labels[i]]) {
            newObj[labels[i]] = requirementObj[labels[i]].length > 10 ? requirementObj[labels[i]].substring(1, 10) + '...' : requirementObj[labels[i]]
          }
        }
      } else {

        Object.keys(requirementObj).forEach(function (key) {
          if (typeof requirementObj[key] == 'string') {
            newObj[key] = requirementObj[key].length > 10 ? requirementObj[key].substring(1, 10) + '...' : requirementObj[key]
          }
        })
        //Object.assign(newObj, requirementObj)
      }
      if (newObj['尺寸长'] && newObj['尺寸宽']) {
        newObj['尺寸(长x宽)'] = `${newObj['尺寸长']} x ${newObj['尺寸宽']}`
        delete newObj['尺寸长']
        delete newObj['尺寸宽']

      }
      delete newObj.title

      let content = JSON.stringify(newObj).replace(/"/g, ' ')
      content = content.replace(/,/g, `、`)
      content = content.replace(/\[/g, ` `)
      content = content.replace(/\]/g, ` `)
      content = content.replace(/\{/g, ` `)
      content = content.replace(/\}/g, ` `)
      return content
    },

    objFilter() {

    },

    // 添加內容
    add: function (obj) {
      let objKey = uuid()
      this.requirements.set(objKey, obj)
      this.gridData.push({ // 前端提交时确认内容表格内容
        hash: objKey,
        description: obj.title,
        content: this.contentFilter(obj)
      })
      this.consignmentItemsAdd(obj, objKey)
      this.subformDialogVisible = true
      return objKey
    },

    // 刪除內容
    del: function (uuid) {
      if (this.requirements.get(uuid)) {
        this.requirements.delete(uuid)
        for (let i = 0; i < this.gridData.length; i++) {
          if (this.gridData[i].hash == uuid) {
            this.gridData.splice(i, 1)
          }
        }
        this.dialogSubmitModifier = false
        this.willChangeAllFormItemObj = {}
        this.willChangeAllFormItemUuid = ""
        this.consignmentItemsDel(uuid)
        return true
      } else {
        return false
      }
    },

    //总表单项目修改：修改前申请
    changeItem: function (uuid) {
      this.willChangeAllFormItemObj = this.requirements.get(uuid)
      this.willChangeAllFormItemUuid = uuid
      this.dialogSubmitModifier = true
    },

    //总表单项目修改：修改后提交
    //通過uuid修改 總表單中的子表單
    change: function (uuid, itemObj) {
      this.requirements.delete(uuid)
      this.requirements.set(uuid, itemObj)
      this.willChangeAllFormItemObj = {}
      this.willChangeAllFormItemUuid = ""
      this.itemFormData = {}
      for (let i = 0; i < this.gridData.length; i++) {
        if (this.gridData[i].hash == uuid) {
          this.gridData[i].content = this.contentFilter(itemObj)
          this.gridData[i].description = itemObj.title
          this.dialogSubmitModifier = false
        }
      }

    },

    //提交数据
    submit: function () {
      let detialObj = Object.create(null)
      for (let [k, v] of this.requirements) {
        detialObj[k] = v
      }
      const postData = {
        Requirement: {
          Nick: this.basicInfo.nick,
          QQ: this.basicInfo.qq,
          Phone: this.basicInfo.phone,
          Service: 1,
          Product: 1,
          Detail: detialObj,
          Status: 1,
        },
        Captcha: {
          token: this.captcha.token,
          captcha: this.captcha.captcha,
        }
      };
      this.allData = postData
      fetch(`${Config.backendBaseUrl}/requirement/create`, {
        method: 'POST',
        body: JSON.stringify(postData),
        headers: new Headers({
          'Content-Type': 'application/json'
        })
      }).then(response => response.json())
        .then(json => this.message(json))
        .catch(error => this.errorAlert(error))

    },// /requirement/create


    //用于弹出对话消息
    message: function (respObj) {
      if (respObj.status == 'faild') {
        this.$notify.error({
          title: '失敗',
          dangerouslyUseHTMLString: true,
          message: `请获取/更新您的验证码重新提交`,
        });

      } else {
        this.$notify({
          title: '成功',
          dangerouslyUseHTMLString: true,
          message: `我们已经收到您的请求<br>（请等待客服人员与您进一步确认）`,
          type: 'success'
        });
      }
    },

    errorAlert: function (content) {
      this.$notify.error({
        title: '失敗',
        dangerouslyUseHTMLString: true,
        message: `${content}`,
      });
    },

    //2019-3-10 實現子表單清空按鈕警告
    clearAlert: function () {
      this.clearFormsConetntAlert = true
    },

    //2019-3-4 為實現 寄賣品單獨的 TAG 添加
    consignmentItemsAdd: function (formDataObj, objKey) {
      if (formDataObj.title == "寄卖相关") {
        this.consignmentItems.push({ key: objKey, value: formDataObj["作品名称"] })
      }
    },
    consignmentItemsDel: function (objkey) {
      for (let i = 0; i < this.consignmentItems.length; i++) {
        if (this.consignmentItems[i].key == objkey) {
          this.consignmentItems.splice(i, 1)
        }
      }
    },
  },

}).$mount('#app')

let screenWidth = document.documentElement.clientWidth || document.body.clientWidth
if (screenWidth > 2000) {
  document.body.style.zoom = 1.2
}